import { createSlice } from "@reduxjs/toolkit";
import { getLatestUploadedDocument } from "../utils/UTILITY_METHODS";

const initialState = {
  pancard: null,
  aadhaarCard: null,
  financialStatements: [],
  bankStatements: [],
  gstInformation: [],
  bureauData: [],
};

const documentsSlice = createSlice({
  name: "documentsDetails",
  initialState: { ...initialState },
  reducers: {
    setDocumentsFromApiCall: (state, action) => {
      const documentsDetails = action.payload;
      documentsDetails.forEach((document) => {
        const documentType = document.document_type;
        const documentSubType = document.document_sub_type;

        if (documentType === "identity_proof") {
          if (documentSubType === "pancard") {
            state.pancard = getLatestUploadedDocument(
              documentsDetails,
              "pancard"
            );
          } else if (documentSubType === "aadhaar_card") {
            state.aadhaarCard = getLatestUploadedDocument(
              documentsDetails,
              "aadhaar_card"
            );
          }
        } else if (
          documentType === "financial_statement" ||
          documentSubType === "financial_statement"
        ) {
          state.financialStatements.push(document);
        } else if (
          documentType === "banking" ||
          documentSubType === "bank_statement"
        ) {
          state.bankStatements.push(document);
        } else if (documentType === "gst" || documentSubType === "gst_report") {
          state.gstInformation.push(document);
        } else if (documentType === "bureau" || documentSubType === "bureau") {
          state.bureauData.push(document);
        }
      });
    },

    removeAllDocuments: () => {
      return { ...initialState };
    },
  },
});

export const { setDocumentsFromApiCall, removeAllDocuments } =
  documentsSlice.actions;
export default documentsSlice.reducer;
